import { useEffect, useState } from 'react';
import APIRequest from '../../../services/APIRequest';
import { useNavigate } from 'react-router-dom';

// Placeholder hook leveraging existing infra; swap actions/services when subscription API is ready
export default function useSubscriptionManagement() {
    const navigate=useNavigate()
    const [loading, setLoading] = useState(false);
    const [subscriptions, setSubscriptions] = useState([]);
    const [totalSubscriptions, setTotalSubscriptions] = useState(0);
    const [currentPage, setCurrentPageState] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

  const [filters, setLocalFilters] = useState({
    search: '',
    planId: '',
    page: 1,
    limit: 10,
  });

  const planOptions = [
    { value: '', label: 'All Plans' },
    // { value: '685a9667b636248e77655aa9', label: 'Free' },
    { value: '68a5f1463e361d7eebb8b6f3', label: 'Standard' },
    { value: '68a5f1463e361d7eebb8b6f4', label: 'Prime' },
    { value: '68a5f1463e361d7eebb8b6f5', label: 'Elite' },
  ];

  useEffect(() => {
    const fetchSubscriptions = async () => {
        try {
          setLoading(true);
          const { search, planId, page, limit } = filters;
          const params = { page: page || 1, limit: limit || 10 };
          if (search?.length) params.search = search;
          if (planId?.length) params.planId = planId;
  
          const resp = await APIRequest.get('admin/subscriptions', params);
          if (resp?.ok) {
            const data = resp.data?.data || [];
            const pagination = resp.data?.pagination || {};
            // map rows to match table expectations
            const rows = data.map((s) => ({
              id: s?._id,
              userId: s?.userId?._id,
              userName: s?.userId?.name||s?.user?.name,
              email: s?.userId?.email||s?.user?.email,
              planName: s.planId?.name,
              planPrice: s?.planId?.price,
              status: s?.status,
              renewalDate: s.currentPeriodEnd || s.endDate,
              raw: s,
            }));
            setSubscriptions(rows);
            setTotalSubscriptions(pagination.total || rows.length);
            setCurrentPageState(pagination.page || 1);
            setTotalPages(pagination.pages || 1);
          } else {
            setSubscriptions([]);
            setTotalSubscriptions(0);
            setCurrentPageState(1);
            setTotalPages(1);
          }
        } finally {
          setLoading(false);
        }
      };
      fetchSubscriptions();
    }, [filters]);

  const setFilters = (newFilters) => {
    setLocalFilters((prev) => ({ ...prev, ...newFilters, page: 1 }));
  };
  const setCurrentPage = (page) => {
    setLocalFilters((prev) => ({ ...prev, page }));
  };
  const clearFilters = () => {
    setLocalFilters({ search: '', planId: '', page: 1, limit: 10 });
  };

  const viewDetail = (row) => {
    // Navigate to subscription detail page
    navigate( `/Admin/Dashboard/Subscription/Detail`,{state:{subscriptionId:row?.id}});
  };

  return {
    subscriptions,
    loading,
    totalSubscriptions,
    currentPage,
    totalPages,
    filters,
    setFilters,
    setCurrentPage,
    clearFilters,
    viewDetail,
    planOptions,
  };
}